<template>
  <div :class="[`${pageClass}-box-main_cont`]" v-loading="paperLoading">
    <div class="main-detail-right">
      <div class="detail-right-box" ref="detail-right-box">
        <ul class="condition" v-show="subjectData.length">
          <li>
            <div class="left">学科：</div>
            <div class="right">
              <div
                v-for="(item, index) in subjectData"
                :class="['span', { active: subjectActive == item.id }]"
                :key="index"
                @click="selectSubject(item.id)"
              >
                {{ item.label }}
              </div>
            </div>
          </li>
        </ul>

        <div class="middle">
          <div class="lable" style="margin-bottom: 10px">提分指南</div>
          <div
            class="tf_content"
            v-if="'9,11'.indexOf(params.subjectId) !== -1"
          >
            <div class="img">
              <img
                @click="toForeword()"
                src="../../assets/images/home/xy.jpg"
              />
            </div>
            <div class="img">
              <img
                @click="toImprove()"
                src="../../assets/images/home/tfmj.jpg"
              />
            </div>
          </div>
          <div class="tf_content" v-else>
            <div class="img" style="width: auto !important">
              <img
                @click="toForeword()"
                src="../../assets/images/home/xy1.jpg"
              />
            </div>
          </div>
        </div>
        <div class="paper_content">
          <div class="lable">专家测评</div>
          <div class="paper_info">
            <div
              class="paper_item"
              v-for="(paper, index) in paperData"
              :key="index"
              @click="toDetail(paper.id)"
            >
              <div class="cover" v-if="subjectActive != 10">
                <img
                  :src="`${backURL}/apis/upload/${paper.tradeGoodsInfo.logoId}`"
                />
              </div>
              <div :class="`paper-cover-shuxue${index + 1}`" v-else>
                <!-- <div class="paper-week">
                  <span>第</span>
                  <div>1</div>
                  <span>周</span>
                </div> -->
                <div class="paper-cover-title">
                  {{ paper.pname }}
                </div>
                <img
                  class="paper-cover-element"
                  :src="
                    require(`../../assets/images/cover/shuxue/shuxue${
                      index + 1
                    }/element.png`)
                  "
                  alt=""
                />
                <div class="great-circle-wai">
                  <div class="great-circle-nei">
                    <div class="small-circle">
                      <img
                        class="cover-pic"
                        :src="
                          require(`../../assets/images/cover/shuxue/shuxue${
                            index + 1
                          }/pic.png`)
                        "
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="info">
                <div class="title">
                  {{ index + 1 + "、" + paper.pname }}
                </div>
                <div class="detail">
                  <div class="item">
                    <div class="label">主讲专家：</div>
                    <div class="text">{{ paper.speaker }}</div>
                  </div>
                  <!-- <div class="item">
                    <div class="label">精讲时长</div>
                    <div class="text">{{ paper.allDuration || 0 }}分钟</div>
                  </div>
                    <div class="text">{{paper.allDuration || 0}}分钟</div>
                  </div> -->
                  <div class="item">
                    <div class="label">试题数量：</div>
                    <div class="text">
                      {{ paper.userLastTestInfo.questionCount }}题
                    </div>
                  </div>
                  <!-- <div class="item">
                    <div class="label">答题时长：</div>
                    <div class="text">{{ paper.duration }}分钟</div>
                  </div> -->
                </div>
              </div>
            </div>
            <template v-if="paperData.length && paperData.length % 4 != 0">
              <div
                class="empty_item"
                v-for="item in new Array(paperData.length % 4)"
                :key="item"
              ></div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { resource } from "../../mixins/my_personal";
import evaluationType from "ASSETS/js/evaluation-type.js";
import qrCode from "@/components/qr-code/qr-code-for-wxpay";
import $ from "jquery";
export default {
  name: "select_subject",
  mixins: [resource],
  data() {
    return {
      dialogVisibleShow: false,
      paperLoading: true,
      havdoInfo: {},
      dialogActive: null, // 选择做题方式
      model: "",
      goodsId: 0,
      activeli: null,
      answerTimes: 0,
      monthNum: 0,
      isAgent: false,
      agentInfo: {},
      shows: false,
      html: "",
      wxPay: false, // 微信支付
      dialogVisible: false,
      active: 3,
      backURL: this.$config.backURL,
      evaluationType,
      pageClass: "select_subject",
      userInfo: {},
      structure: true, // 结构展示形式
      paperData: [],
      loading: false,
      totalCount: 0, // 总页数
      timeInterval: [], // 时间区间
      tabActive: 0,
      subjectActive: -1, // 学科选中时下标
      dialogVisibleSelectType: false,
      params: {
        // 筛选条件
        orderBy: "3",
        rule: 1,
        subjectId: null,
        appId: 100,
        dateType: null,
        pageIndex: 1,
        pageSize: 100
      },
      paper: {},
      detailLoading: false,
      subjectData: [],
      subjectList: [
        {
          id: 10,
          label: "数学"
        },
        {
          id: 12,
          label: "物理"
        },
        {
          id: 11,
          label: "英语"
        },
        {
          id: 9,
          label: "语文"
        },
        {
          id: 13,
          label: "化学"
        },
        {
          id: 14,
          label: "生物"
        },
        {
          id: 16,
          label: "地理"
        },
        {
          id: 15,
          label: "历史"
        },
        {
          id: 17,
          label: "政治"
        }
      ],
      orderInfo: {},
      activeInfo: {
        subjectList: []
      },
      paperAlltotal: 0, // 活动期间任意学科购买总数
      singleFamily: 0, //  活动期间单科购买次数
      limitSubject: 0, // 是否限制学科 0 不限学科 1 限制学科
      subjectShowPreferential: [], // 展示的学科数组
      oldUser: 0, // 查看老用户购买次数
      price: 0, // 余额信息
      testId: null
    };
  },

  methods: {
    getSubjectList() {
      this.$HTTP
        .executePost(
          this.$APIS.GET_EXPERT_EVALUATION_SUBJECTID,
          { appId: 100 },
          this
        )
        .then(res => {
          if (!res.code) {
            const list = res.data;
            const subjectArr = [];
            for (let i = 0; i < list.length; i++) {
              const element1 = list[i].subjectId;
              for (let index = 0; index < this.subjectList.length; index++) {
                const element2 = this.subjectList[index];
                if (element1 == element2.id) {
                  subjectArr.push(element2);
                }
              }
            }
            subjectArr.splice(0, 0, subjectArr.splice(1, 1)[0]);
            console.log("subjectArr ==> ", subjectArr);
            let tempIndexs = [];
            subjectArr.forEach(item => {
              let index = this.subjectList.getFirstIndexByItem("id", item.id);
              if (index != null) {
                tempIndexs.push(index);
              }
            });
            tempIndexs.sort();
            let result = [];
            tempIndexs.forEach(e => {
              result.push(this.subjectList[e]);
            });

            this.subjectData = result;
          } else {
            this.$message.error("调用接口失败");
          }
        });
    },
    toDetail(paperId) {
      this.$router.push({
        path: "detail",
        query: {
          id: this.params.subjectId,
          paper_id: paperId
        }
      });
    },
    toForeword() {
      let routeData = this.$router.resolve({
        path: "/foreword",
        query: {
          path: this.paperData[0].improveScore
        }
      });
      window.open(routeData.href, "_blank");
    },
    toImprove() {
      if (this.params.subjectId != 12 && this.params.subjectId != 10) {
        let routeData = this.$router.resolve({
          path: "/improve",
          query: {
            subjectId: this.params.subjectId
          }
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$message("暂无提分秘籍视频");
      }
    },
    // 筛选科目
    selectSubject(ind) {
      // this.active = 3;
      this.tabActive = 0;
      if (ind == "no") {
        delete this.params.subjectId;
        this.subjectActive = -1;
      } else {
        localStorage.setItem("chooseSubjectId", ind);
        sessionStorage.setItem("subjectId", ind);
        this.params.subjectId = ind;
        this.subjectActive = ind;
        this.$router.push({
          path: "/tfedu_common/expert",
          query: {
            id: ind
          }
        });
      }
      this.getPaperList();
    },
    // 点击分页
    currentIndex(val) {
      this.params.pageIndex = +val;
      this.getPaperList();
    },
    // 获取数据
    getPaperList() {
      this.loading = true;
      this.$HTTP
        .executePost(this.$APIS.GET_PAPER_PARAM, this.params, this)
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.paperData = res.data.list;
            this.params.pageIndex = res.data.pageIndex;
            this.totalCount = res.data.total;

            // 获取第一个试卷
            let id = res.data.list[0].id || this.$route.query.paper_id;
            this.goodsId = res.data.list[0].tradeGoodsInfo.id;
            this.activeli = id;
          }
        });
    },
    // 第一次获取
    getFistPaperList() {
      this.loading = true;
      this.$HTTP
        .executePost(this.$APIS.GET_PAPER_PARAM, this.params, this)
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            // this.paperData = res.data.list.reverse();
            this.paperData = res.data.list;
            this.params.pageIndex = res.data.pageIndex;
            this.totalCount = res.data.total;

            if (this.$route.query.paper_id) {
              // if (this.$route.query.paper_id == res.data.list[0].id) {
              //   this.active = 3;
              // } else {
              //   this.active = 1;
              // }
              for (let i = 0; i < res.data.list.length; i++) {
                const goods = res.data.list[i];
                if (this.$route.query.paper_id == goods.id) {
                  this.goodsId = goods.tradeGoodsInfo.id;
                }
              }
            } else {
              this.goodsId = res.data.list[0].tradeGoodsInfo.id;
            }
          }
          this.paperLoading = false;
        });
    }
  },
  created() {
    this.activeli = this.$route.query.paper_id || 0;
    // 兼容客户端
    let source = localStorage.getItem("model") || this.$route.query.model || "";
    this.model = source;
    localStorage.setItem("model", source);
    try {
      CefSharp.BindObjectAsync("cefJS");
    } catch (error) {
      console.log(error);
    }
    // 首版隐藏
    // this.$store.dispatch('selectTabType', 'expert')
    // 首版展示
    this.$store.dispatch("selectTabType", "home");

    this.getSubjectList();
    this.params.subjectId =
      this.$route.query.id || sessionStorage.getItem("subjectId") || 10;
    this.subjectActive =
      this.$route.query.id || sessionStorage.getItem("subjectId") || -1;
    this.params.dateType = this.$route.query.time;
    this.timeActive = this.$route.query.time || -1;
    this.getFistPaperList();

    if (this.$route.query.code != null && this.$route.query.code != 0) {
      this.dialogVisible = true;
    }
    let user_json = localStorage.getItem("userinfo");
    this.userInfo = JSON.parse(user_json);
  },
  mounted() {
    $("body").css("background", "#f5f5f5");
  }
};
</script>

<style lang="scss" scoped>
.select_subject-box-main_cont {
  width: 100%;
  min-height: 100%;
  height: auto;
  margin: 0 auto;
  position: relative;
  overflow: auto;
  .main-detail-right {
    width: 1400px;
    margin: 0 auto;
    height: auto;
    padding-left: 0;
    position: relative;
    .detail-right-box {
      position: absolute;
      bottom: 20px;
      top: 20px;
      right: 0;
      left: 0px;
      width: 100%;
      .lable {
        font-size: 24px;
        height: 30px;
        width: 100%;
        line-height: 2;
      }
      .middle {
        position: absolute;
        margin-top: 50px;
        height: auto;
        width: 100%;
        .tf_content {
          width: 100%;
          height: 200px;
          margin-top: 20px;
          display: inline-flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          flex: 1;
          .img {
            width: 680px;
            height: 200px;
            padding: 10px 10px 10px 10px;
            background-color: #fff;
            cursor: pointer;
            img {
              height: 100%;
              width: 100%;
            }
          }
        }
      }

      .paper_content {
        position: absolute;
        min-height: 520px;
        height: auto;
        width: 100%;
        margin-top: 320px;
        padding: 0px 0px 0px 0px;
        .paper_info {
          margin-top: 0px;
          display: flex;
          width: 100%;
          height: auto;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;

          :last-child {
            content: "";
            justify-self: flex-start;
          }
        }
        .paper_item {
          width: 320px;
          min-height: 316px;
          background: #fff;
          padding: 10px 10px 10px 10px;
          margin-top: 30px;
          position: relative;
          cursor: pointer;
          .cover {
            width: 300px;
            height: 196px;
            // position: absolute;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .info {
            height: 108px;
            width: 300px;
            background: #fff;
            padding: 0 11px;
            .title {
              width: 100%;
              padding-top: 14px;
              font-family: MicrosoftYaHei;
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              color: #585858;
            }
            .detail {
              width: 100%;
              color: #aaaaaa;
              // display: flex;
              // flex-wrap: wrap;
              // justify-content: space-between;
              // align-content: space-between;
              // justify-items: center;
              // align-items: center;
              font-size: 14px;
              margin-top: 9px;
              .item {
                display: flex;
                justify-content: flex-start;
                flex-wrap: nowrap;
                // width: 50%;
                font-size: 0.075rem;
                line-height: 28px;
                .label {
                  color: #aaaaaa;
                }
                .text {
                  color: #aaaaaa;
                }
              }

              .title {
                width: 100%;
                padding: 5px 15px 5px 15px;
                height: 75px;
                font-family: MicrosoftYaHei;
                font-size: 0.1rem;
                font-weight: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: 0px;
                color: #585858;
              }
            }
          }
        }
        .empty_item {
          width: 320px;
          height: 0px;
          background: #fff;
          position: relative;
          cursor: pointer;
        }
      }
    }
    .condition {
      top: 0px;
      left: 0;
      right: 0;
      height: 72px;
      display: inline-flex;
      justify-content: center;
      flex: 1;
      height: auto;
      width: 100%;
      margin: 0 auto;
      li {
        height: 72px;
        font-size: 20px;
        display: inline-flex;
        justify-content: space-around;
        .left {
          width: 78px;
          line-height: 72px;
          color: #aaaaaa;
        }

        .right {
          flex: 1;
          height: auto;
          flex-wrap: wrap;
          cursor: pointer;

          .span {
            width: 90px;
            height: 36px;
            text-align: center;
            line-height: 36px;
            border-radius: 18px;
            float: left;
            margin-right: 25px;
            color: #585858;
            margin-top: 18px;
            cursor: pointer;
          }

          .span:hover {
            color: #0072ff;
            background: #fff;
          }
          .active {
            color: #0072ff;
            background: #fff;
          }
        }
      }
      .li-bottom {
        border-bottom: 1px solid #aaaaaa;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "../../assets/css/cover/shuxue.scss";
</style>
